exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".accordion-body{overflow:hidden;-webkit-transition-property:height;transition-property:height;-webkit-transition-timing-function:cubic-bezier(.46,.29,.69,.46);transition-timing-function:cubic-bezier(.46,.29,.69,.46)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76acace3","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/transitions/SlideToggle.vue
// module id = gLn6
// module chunks = 0